/* __next_internal_client_entry_do_not_use__  cjs */ "use strict";
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
const DialogContext = /*#__PURE__*/ React.createContext({});
if ("production" !== 'production') {
    DialogContext.displayName = 'DialogContext';
}
var _default = exports.default = DialogContext;
